<template lang="pug">
  .home-slides(:class="active? 'active': ''")
    .swiper-container(ref="swiper")
      .swiper-wrapper
        .swiper-slide.footprint
          .card
            events-card
        .swiper-slide.footprint
          .card
            footprint-card    
        //- .swiper-slide.events
        //-   .card
        //-     space-card            
        .swiper-slide.intro
          .card
            intro-card
</template>

<script>
import Swiper from "swiper"
import ResizeService from "@/services/ResizeService"
import IntroCard from "@/components/home/IntroCard"
import EventsCard from "@/components/home/EventsCard"
import SpaceCard from "@/components/home/SpaceCard"
import FootprintCard from "@/components/home/FootprintCard"
import { mapGetters, mapMutations, mapState } from "vuex"
import gsap from "gsap"

let mySwiper

export default {
  name: "HomeSlides",
  components: { EventsCard, IntroCard, SpaceCard, FootprintCard },
  data() {
    return {
      active: false,
    }
  },
  computed: {
    ...mapState("app", ["user", "appStatus"])
  },
  watch: {
    appStatus() {
      this.$nextTick(() => {
        mySwiper && mySwiper.update()
        mySwiper && mySwiper.slideTo(0)
      })
    }
  },
  mounted() {
    const that = this
    setTimeout(() => {
      mySwiper = new Swiper(that.$refs.swiper, {
        direction: "horizontal",
        slidesPerView: "auto",
        spaceBetween: 30,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0
      })
      console.log(mySwiper)
    }, 30)
  },
  methods: {
    animeIn(offsets) {
      // gsap.fromTo(
      //   this.$el,
      //   {
      //     opacity: 0,
      //   },
      //   {
      //     opacity: 1,
      //     duration: 0.7,
      //   }
      // )
      this.active = true
    }
  }
}
</script>

<style scoped lang="sass">
@import "~swiper/swiper-bundle.min.css"
@import "src/styles/common.sass"
.home-slides
  position: relative
  &.active
    .footprint
      animation-name: CardFadeIn
      animation-fill-mode: both
      animation-timing-function: $easeOutCubic
    .intro
      animation-name: CardFadeIn
      animation-fill-mode: both
      animation-timing-function: $easeOutCubic
    .events
      animation-name: CardFadeIn
      animation-fill-mode: both
      animation-timing-function: $easeOutCubic
  .swiper-container
    overflow: visible
    position: relative
    //background: #f7a41a
    width: 100%
    height: 100%
    .swiper-slide
      //background: #fff
      width: pxToRem(370)
      height: pxToRem(430)
      display: flex
      justify-content: center
      align-items: center
      transform-origin: center
      .card
        width: 100%
        height: pxToRem(430)
    .footprint
      opacity: 0
      animation-delay: 0.1s
      animation-duration: 0.7s
    .intro
      opacity: 0
      animation-delay: 0.1s
      animation-duration: 0.7s
    .events
      opacity: 0
      animation-delay: 0.2s
      animation-duration: 0.7s
@keyframes CardFadeIn
  0%
    opacity: 0
    transform: scale(0.75) translateY(30%)
  100%
    opacity: 1
    transform: scale(1) translateY(0)
</style>
